import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

import styled from 'styled-components';
import '../../../utils/assertions.es.js';
import 'react';
import '../../../utils/responsive.es.js';
import '../../../utils/scrollIntoView.es.js';
import { spacing, palette } from '../../../utils/theme.es.js';
import '../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import Button from '../../Button/Button.es.js';
import { Box } from '../../../primitives/Box/Box.es.js';
var ListItem = styled(Button).withConfig({
  componentId: "kkj4zr-0"
})(["padding:0 ", ";button{flex-shrink:0;}.highlight{background:", ";}"], spacing("lg"), palette("primary.500", 0.24));
var SubItemsWrapper = styled.div.withConfig({
  componentId: "kkj4zr-1"
})(["> li > button{padding:0 ", ";}"], spacing("jb"));
var ListFilterWrapper = styled.div.withConfig({
  componentId: "kkj4zr-2"
})(["width:320px;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoint("md")(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        width: 100%;\n    "])));
});
var ListItemsScrollContainer = styled(Box).withConfig({
  componentId: "kkj4zr-3"
})(["height:314px;overflow:auto;", " ", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoint("md")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        height: 100%;\n    "])));
}, function (props) {
  return "\n        height: " + props.height + ";\n    ";
});
var ListItemsItem = styled.li.withConfig({
  componentId: "kkj4zr-4"
})(["display:flex;justify-content:center;cursor:pointer;button{border-radius:0;div{transition:all 0ms;}}:hover{background-color:", ";button,div{background-color:", ";}}"], palette("neutral.700", 1), palette("neutral.700", 1));
var CaretDownWrapper = styled(Box).withConfig({
  componentId: "kkj4zr-5"
})(["color:", ";:hover{color:", ";}", ""], palette("neutral.400", 1), palette("neutral.50"), function (_ref3) {
  var areSubItemsVisible = _ref3.areSubItemsVisible;
  return areSubItemsVisible && "\n        svg {\n            transform: rotate(180deg);\n        }\n    ";
});
export { CaretDownWrapper, ListFilterWrapper, ListItem, ListItemsItem, ListItemsScrollContainer, SubItemsWrapper };